<template>
<!-- -->
  <div>
    <div class="no-select" style="min-height:520px;position:relative;z-index:0;" :class="{'drag': isDrag}" :style="containerStyle" v-loading="loading">
    <!-- 左侧栏 -->
    <input-type :tabInputs="tabInputs" :curType="curType" width="200px" :isDrag="isDrag" @setIsDrag="setIsDrag" @setCurType="setCurType"></input-type>
    <!-- 左侧栏 -->
    <!-- 中间栏 -->
    <input-list ref="inputList" :formName="formName" :inputList="submitInputs" width="calc((100% - 200px) / 2)" height="95%" :curType="curType" :curInput="curInput" :isDrag="isDrag" @setCurInput="setCurInput" @setIsDrag="setIsDrag" @setCurType="setCurType"></input-list>
    <!-- 中间栏 -->
    <!-- 右侧栏 -->
    <right-config :curInput="curInput" :inputList="submitInputs" width="calc((100% - 200px) / 2)"></right-config>
    <!-- 右侧栏 -->
    
    <div style="clear:both"></div>
    <div class="fl m-t-10">
      <el-button size="small" @click="importData">导入数据</el-button>
      <el-button size="small" @click="exportData">导出数据</el-button>
      <el-button id="copy" size="small" :data-clipboard-text="copyJson" @click="copyData">复制数据</el-button>
      <el-button size="small" @click="importTextData">导入文本数据</el-button>
    </div>
    <div class="m-t-10 tx-c">
      <el-button type="primary" @click="submit()" :loading="isLoading">提交</el-button>
      <el-button @click="goback()">返回</el-button>
    </div>
    <div>
      <input id="importFile" type="file" v-show="false" @change="importFileChange">
      <a id="exportData" href="#" download v-show="false"></a>
    </div>
  </div>
  <!-- 文本框弹窗 -->
  <text-import ref="textImport" @setImportText="setImportText"></text-import>
  <!-- 文本框弹窗 -->
  <!-- 配置值导入弹窗 -->
  <import-config-dialog
    ref="importConfig"
    v-if="isImportConfig"
    :selectConfig="selectConfig"
    :onlyName="onlyName">
  </import-config-dialog>
  <!-- 配置值导入弹窗 -->
  </div>
</template>
<style>
  .drag {
    cursor: move;
  }
  .min-h-550 {
    min-height:550px
  }
  .panel-c-c {
    /*z-index: 0;*/
  }
  .no-select:before {
    user-select: none;
    -webkit-user-select: none;
  }
</style>
<script>
  import http from '../../assets/js/http'
  import modelConfig from '../../config/modelConfig'
  import rightConfig from './rightConfig'
  import inputList from './inputList'
  import inputType from './inputType'
  import textImport from './textImport'
  import Clipboard from 'clipboard'
  import importConfigDialog from './configComponents/importConfigDialog.vue'
  export default {
    data() {
      return {
        id: null,
        loading: false,
        isLoading: false,
        curType: {}, // 当前拖拽的类型
        curInput: {
          default: {}
        }, // 当前选中的控件
        submitInputs: [], // 已添加的控件列表
        tabInputs: [  // 可选控件类型
          { id: 10, name: '单行文本', icon: 'fa-i-cursor', field_name: 'input' },
          { id: 20, name: '密码', icon: 'fa-lock', field_name: 'password' },
          { id: 30, name: '多行文本', icon: 'fa-align-left', field_name: 'textarea' },
          { id: 40, name: '单选框', icon: 'fa-dot-circle-o', field_name: 'radio' },
          { id: 50, name: '复选框', icon: 'fa-check-square-o', field_name: 'checkbox' },
          { id: 60, name: '下拉框', icon: 'fa-chevron-down', field_name: 'select' },
          { id: 70, name: '日期', icon: 'fa-calendar-o', field_name: 'date' },
          { id: 80, name: '日期时间', icon: 'fa-calendar-times-o', field_name: 'datetime' },
          { id: 90, name: '时间', icon: 'fa-clock-o', field_name: 'time' },
          { id: 100, name: '富文本', icon: 'fa-wpforms', field_name: 'editor' },
          { id: 110, name: '级联选择', icon: 'fa-list-ol', field_name: 'link' },
          { id: 120, name: '外键选择', icon: 'fa-reply-all', field_name: 'key' },
          { id: 130, name: '子表单', icon: 'fa-th', field_name: 'form' },
          { id: 140, name: '文件上传', icon: 'fa-upload', field_name: 'file' },
          { id: 150, name: '人员选择', icon: 'fa-user-o', field_name: 'people' },
          { id: 160, name: '部门选择', icon: 'fa-users', field_name: 'struct' },
          { id: 170, name: '获取用户信息', icon: 'fa-address-card', field_name: 'userInfo' },
          { id: 180, name: '获取系统时间', icon: 'fa-calendar', field_name: 'dealtime' },
          { id: 190, name: '字段拓展管理', icon: 'fa-file-code-o', field_name: 'params' },
          { id: 200, name: '多对多关联', icon: 'fa-asterisk', field_name: 'multi_link' },
          { id: 210, name: '图片', icon: 'fa-image', field_name: 'photo' },
          { id: 220, name: '子表数据关联', icon: 'fa-cogs', field_name: 'child' },
          { id: 230, name: '接口获取内容', icon: 'fa-cogs', field_name: 'obtain_content' }
        ],
        containerStyle: {},  // 设置容器高度
        isDrag: false, // 是否正在拖拽
        illegal: /[\b\t\s\n]/g,  // 转义符黑名单
        formName: '', // 当前表前缀名
        importText: '',
        copyJson: '',
        clipboard: null,
        isImportConfig: false,
        onlyName: false,
        selectConfig: []
      }
    },
    components: {
      rightConfig,
      inputList,
      inputType,
      textImport,
      importConfigDialog
    },
    created() {
      this.id = this.$route.query.id
      this.formName = this.$route.query.name
      this.loading = true
      this.init()
      this.getInputList()
      this.addFormName()
      setTimeout(() => {
        let copybtn = document.getElementById('copy')
        this.clipboard = new Clipboard(copybtn)
        this.clipboard.on('success', (e) => {
          _g.toastMsg(this, 'success', '已复制到剪贴板')
        })
      })
    },
    destroyed() {
      // 移除表单字段缓存
      Lockr.rm('fields')
      Lockr.rm('foreignFields')
    },
    methods: {
      addFormName() { // 添加表前缀
        this.tabInputs.forEach((item) => {
          item.field_name = this.formName + '_' + item.field_name
        })
      },
      getInputList() { // 获取控件数据
        this.apiGet(`form/models/${this.id}/fields`).then((res) => {
          if (res.code == 200) {
            this.initData(res.data)
            this.loading = false
          } else {
            _g.dealError(this, res)
          }
        })
      },
      init() {  // 初始化，绑定事件
        this.resize()
        window.onresize = () => {
          this.resize()
        }
        document.addEventListener('mouseup', (event) => {
          this.isDrag = false
          this.curType = {}
        })
      },
      initData(data) {  // 处理数据
        if (data) { // 兼容旧数据
          let textNewField = {  // 单行文本相关新字段
            min_limit: '',
            max_limit: ''
          }
          _(data).forEach((res) => {
            if (res && res.default && res.default.type == 10) { // 单行文本类型
              _(textNewField).forEach((item, key) => {
                if (res.input && !res.input.hasOwnProperty(key)) {
                  res.input[key] = item
                }
              })
            }
          })
        }
        _(data).forEach((item) => {
          item.selected = false
          item.default.is_deleted = 0
          item.hide = false
          item.isDulpicate = false
          // if (item.default.name.indexOf(this.formName) == -1) {
          //   item.default.name = this.formName + '_' + item.default.name
          // }
          // 判断是否有子表单的存在 赋值is_deleted
          if (item.form && item.form.data && item.form.data.length > 0) {
            let tempData = item.form.data
            _(tempData).forEach((res) => {
              res.selected = false
              res.hide = false
              res.default.is_deleted = 0
              res.isDulpicate = false
            })
          }
        })
        _(data).forEach((item) => {
          if (item.default.type == this.TYPE_SUBFORM && item.form.data) {
            _(item.form.data).forEach((child) => {
              child.selected = false
            })
          } else if (item.default.type == this.TYPE_FILE) {
            item.file.checkAllFile = false
          } else if (item.default.type == this.TYPE_EDITOR) {
            item.editor.checkAllPcMenu = false
          }
        })
        this.submitInputs = data
        if (this.submitInputs.length) {
          this.$refs.inputList.selectInput(this.submitInputs[0])
        }
      },
      resize() {  // 设置窗口高度
        this.containerStyle = {
          height: window.innerHeight - 120 + 'px'
        }
      },
      setIsDrag(isDrag) {     // 设置拖拽标志
        this.isDrag = isDrag
      },
      setCurType(curType) {   // 设置当前拖拽的控件类型
        this.curType = curType
      },
      setCurInput(curInput) { // 设置当前选择的控件
        if (this.curInput.default && this.curInput.default.type) {
          this.curInput.selected = false
        }
        curInput.selected = true
        this.curInput = curInput
      },
      isFieldName(value) {
        return (/^[A-za-z][A-za-z0-9]+$/g).test(value)
      },
      importFileChange() {  // 读取导入的文件数据
        let fileInput = document.getElementById('importFile')
        let file = fileInput.files[0]
        let fileReader = new FileReader()
        fileReader.onload = (event) => {
          _g.catchError(this, () => {
            let result = event.target.result
            result = JSON.parse(result)
            result = this.removeFieldId(result)
            _(result).forEach((res) => {
              res.selected = false
            })
            this.submitInputs = Array.concat(this.submitInputs, result)
          }, '导入失败！')
        }
        fileReader.readAsText(file)
      },
      exportData() {  // 导出数据
        let data = this.beforePost(_.cloneDeep(this.submitInputs))
        data = JSON.stringify(data)
        let blob = new Blob([data], { type: 'text/plain;charset=utf-8' })
        let a = document.getElementById('exportData')
        a.download = 'data.json'
        a.href = URL.createObjectURL(blob)
        a.click()
      },
      importData() {  // 导入数据
        let fileInput = document.getElementById('importFile')
        fileInput.click()
      },
      importTextData() {  // 打开导入文本数据弹窗
        this.$refs.textImport.openDialog()
      },
      copyData() { // 复制数据
        this.copyJson = JSON.stringify(this.submitInputs)
      },
      removeFieldId(data) {
        _(data).forEach((res) => {
          if (res.default.field_id) {
            delete res.default.field_id
          }
          if (res.default.type == this.TYPE_SUBFORM) {
            res.form.data = this.removeFieldId(res.form.data)
          }
        })
        return data
      },
      setImportText(type, text) { // 设置导入的数据
        if (type == 'text') { // 特殊文本
          let arr = text.split('\n')
          let success = 0
          let fail = 0
          _(arr).forEach((res) => {
            if (res.indexOf('|') > -1) {
              let inputData = res.split('|')
              let inputModel = {
                type: '',
                name: '',
                title: '',
                tips: '',
                is_needed: ''
              }
              if (inputData.length >= 5) {
                let i = 0
                _(inputModel).forEach((item, key) => {
                  inputModel[key] = inputData[i++].trim().replace(/\s/g, '')
                })
              } else {
                fail++
                return
              }
              inputModel.is_needed = parseInt(inputModel.is_needed)
              let foundType = false
              _(this.tabInputs).forEach((input) => {
                if (input.name == inputModel.type) {
                  inputModel.type = input.id
                  foundType = true
                  return false
                }
              })
              if (!foundType) {
                fail++
                return
              }
              this.$refs.inputList.addInput(inputModel.type, inputModel, true)
              success++
            } else {
              fail++
            }
          })
          _g.toastMsg(this, 'success', `成功导入数据${success}条，失败${fail}条`)
        } else {
          let data = ''
          _g.catchError(this, () => {
            data = JSON.parse(text)
            if (_.isArray(data)) {  // 是数组
              _(data).forEach((res) => {
                res.selected = false
              })
              data = this.removeFieldId(data)
              // console.log(data)
              this.submitInputs = this.submitInputs.concat(data)
            } else if (_.isObject(data)) {  // 是对象
              if (data.default.field_id) {
                delete data.default.field_id
                if (data.default.type == this.TYPE_SUBFORM) {
                  data.form.data = this.removeFieldId(data.form.data)
                }
              }
              data.selected = false
              this.submitInputs.push(data)
            } else {
              _g.toastMsg(this, 'warning', '数据格式有误，无法导入')
              return
            }
            _g.toastMsg(this, 'success', '导入成功')
          }, '数据格式有误，无法导入')
        }
      },
      beforePost(postData) {  // 提交前的数据处理
        let sort = 0
        postData.forEach((item, index) => {
          item.default.name = item.default.name.replace(this.illegal, '')
          if (!item.is_deleted && item.default) {
            item.default.sort = sort++
          }
          if (item.default.type == this.TYPE_FILE) {
            delete item.file.checkAllFile
          }
          if (item.default.type == this.TYPE_EDITOR) {
            delete item.editor.checkAllPcMenu
          }
          if (item.default.type == this.TYPE_RADIO) {
            _.remove(item.radio_option, (res) => {
              return res.name === '' || res.value === ''
            })
          }
          if (item.default.type == this.TYPE_CHECKBOX) {
            _.remove(item.checkbox_option, (res) => {
              return res.name === ''
            })
          }
          if (item.default.type == this.TYPE_SELECT) {
            _.remove(item.select_option, (res) => {
              return res.name === '' || res.value === ''
            })
          }
          delete item.selected
        })
        return postData
      },
      submit() {
        let postData = _.cloneDeep(this.submitInputs)
        postData = this.beforePost(postData)
        let nameToLong = false
        let notFieldName = false
        _(postData).forEach((res) => {
          if (!this.isFieldName(res.default.name)) {
            notFieldName = true
          }
          if (res.default.name && res.default.name.length > 64) {
            nameToLong = true
            return false
          }
        })
        if (notFieldName) {
          _g.toastMsg(this, 'warning', '字段名只能输入英文、数字和下划线')
          return
        }
        if (nameToLong) {
          _g.toastMsg(this, 'warning', '字段名长度不能超过64')
          return
        }
        this.isLoading = true
        this.apiPost(`form/models/${this.id}/fields`, { data: postData }).then((res) => {
          if (res.code == 200) {
            this.isLoading = false
            _g.toastMsg(this, 'success', '保存成功')
            setTimeout(() => {
              router.go(-1)
            }, 1500)
          } else {
            this.isLoading = false
            _g.dealError(this, res)
          }
        })
      },
      getImportConfigData(inputOption, tempArr, lengthA, lengthB) { // 获取分析导入数据
        if (lengthA > lengthB) {
          inputOption.splice(lengthB - 1, lengthA - lengthB)
          this.postInputOptionValue(tempArr, inputOption)
        } else if (lengthA < lengthB) {
          _(tempArr).forEach((res, index) => {
            if (lengthA < index + 1) {
              let model
              if (!this.onlyName) {
                model = {
                  is_selected: 0,
                  value: res.value,
                  name: res.name
                }
              } else {
                model = {
                  is_selected: 0,
                  name: res.name
                }
              }
              inputOption.push(model)
            } else {
              if (!this.onlyName) {
                inputOption[index].value = res.value
                inputOption[index].name = res.name
              } else {
                inputOption[index].name = res.name
              }
            }
          })
        } else {
          this.postInputOptionValue(tempArr, inputOption)
        }
      },
      postInputOptionValue(tempArr, inputOption) {
        if (!this.onlyName) {
          _(tempArr).forEach((res, index) => {
            inputOption[index].value = res.value
            inputOption[index].name = res.name
          })
        } else {
          _(tempArr).forEach((res, index) => {
            inputOption[index].name = res.name
          })
        }
      },
      goback() {
        router.go(-1)
      }
    },
    watch: {
      '$store.state.isImportDialogUpdate'() {
        let self = this
        if (store.state.isImportDialogUpdate) {
          // 打开导入对话框
          self.isImportConfig = true
          self.onlyName = false
          self.selectConfig = []
          if (this.curInput.default) {
            if (this.curInput.default.type === this.TYPE_RADIO) {
              self.selectConfig = this.curInput.radio_option
              self.onlyName = false
            } else if (this.curInput.default.type === this.TYPE_CHECKBOX) {
              self.selectConfig = this.curInput.checkbox_option
              self.onlyName = true
            } else if (this.curInput.default.type === this.TYPE_SELECT) {
              self.selectConfig = this.curInput.select_option
              self.onlyName = false
            }
          }
          store.state.isImportDialogUpdate = false
          setTimeout(() => {
            self.$refs.importConfig.openDialog()
          })
        }
      },
      '$store.state.isImportDialogClose'() {
        // 关闭输入框处理事件
        let self = this
        if (store.state.isImportDialogClose) {
          setTimeout(() => {
            self.isImportConfig = false
            store.state.isImportDialogClose = false
          })
          let inputOption = []
          let tempArr = store.state.importConfigData
          if (this.curInput.default) {
            if (this.curInput.default.type === this.TYPE_RADIO) {
              inputOption = this.curInput.radio_option
            } else if (this.curInput.default.type === this.TYPE_CHECKBOX) {
              inputOption = this.curInput.checkbox_option
            } else if (this.curInput.default.type === this.TYPE_SELECT) {
              inputOption = this.curInput.select_option
            }
          }
          let lengthA = inputOption.length
          if (!tempArr) {
            inputOption.splice(0, lengthA)
            return
          }
          let lengthB = tempArr.length
          this.getImportConfigData(inputOption, tempArr, lengthA, lengthB)
        }
      }
    },
    mixins: [http, modelConfig]
  }
</script>


// WEBPACK FOOTER //
// design.vue?4287d9a0